import PropTypes from 'prop-types'

/** Inline SVG icons shared across the Life Story experience. */

export const MicIcon = ({size = 19, strokeWidth = 1.8}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth={strokeWidth} strokeLinecap='round' aria-hidden='true'>
    <rect x='9' y='2' width='6' height='12' rx='3' />
    <path d='M5 10a7 7 0 0014 0M12 17v4M8 21h8' />
  </svg>
)

MicIcon.propTypes = {
  size: PropTypes.number,
  strokeWidth: PropTypes.number
}

export const CaretIcon = ({size = 13}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2.4' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
    <path d='M6 9l6 6 6-6' />
  </svg>
)

CaretIcon.propTypes = {size: PropTypes.number}

export const ChevronRightIcon = ({size = 18}) => (
  <svg
    width={size}
    height={size}
    viewBox='0 0 24 24'
    fill='none'
    stroke='currentColor'
    strokeWidth='2'
    strokeLinecap='round'
    strokeLinejoin='round'
    aria-hidden='true'>
    <path d='M9 6l6 6-6 6' />
  </svg>
)

ChevronRightIcon.propTypes = {size: PropTypes.number}

export const PhotoIcon = ({size = 18}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='1.8' strokeLinecap='round' strokeLinejoin='round' aria-hidden='true'>
    <rect x='3' y='4.5' width='18' height='15' rx='2.5' />
    <circle cx='9' cy='10' r='1.8' />
    <path d='M21 15.5l-5-5-8.5 9' />
  </svg>
)

PhotoIcon.propTypes = {size: PropTypes.number}

export const PlayIcon = ({size = 18}) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='currentColor' aria-hidden='true'>
    <path d='M6 4l10 6-10 6V4z' />
  </svg>
)

PlayIcon.propTypes = {size: PropTypes.number}

export const PauseIcon = ({size = 18}) => (
  <svg width={size} height={size} viewBox='0 0 20 20' fill='currentColor' aria-hidden='true'>
    <rect x='5' y='4' width='3.5' height='12' rx='1' />
    <rect x='11.5' y='4' width='3.5' height='12' rx='1' />
  </svg>
)

PauseIcon.propTypes = {size: PropTypes.number}

/* ---------- "Refine" (TK-3204) ---------- */

const strokeProps = strokeWidth => ({
  fill: 'none',
  stroke: 'currentColor',
  strokeWidth,
  strokeLinecap: 'round',
  strokeLinejoin: 'round',
  'aria-hidden': 'true'
})

export const WandIcon = ({size = 19}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(1.9)}>
    <path d='m21.64 3.64-1.28-1.28a1.21 1.21 0 0 0-1.72 0L2.36 18.64a1.21 1.21 0 0 0 0 1.72l1.28 1.28a1.2 1.2 0 0 0 1.72 0L21.64 5.36a1.2 1.2 0 0 0 0-1.72' />
    <path d='m14 7 3 3M5 6v4M19 14v4M10 2v2M7 8H3M21 16h-4M11 3H9' />
  </svg>
)

WandIcon.propTypes = {size: PropTypes.number}

export const SparkleIcon = ({size = 17}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z' />
  </svg>
)

SparkleIcon.propTypes = {size: PropTypes.number}

export const PolishIcon = ({size = 17}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M12 3l1.9 5.1L19 10l-5.1 1.9L12 17l-1.9-5.1L5 10l5.1-1.9z' />
    <path d='M19 17l.7 1.8 1.8.7-1.8.7L19 22l-.7-1.8-1.8-.7 1.8-.7z' />
  </svg>
)

PolishIcon.propTypes = {size: PropTypes.number}

export const ShortenIcon = ({size = 17}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M4 7h16M4 12h10M4 17h6' />
  </svg>
)

ShortenIcon.propTypes = {size: PropTypes.number}

export const EnrichIcon = ({size = 17}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M4 7h16M4 12h16M4 17h9' />
    <path d='M18 15v6M15 18h6' />
  </svg>
)

EnrichIcon.propTypes = {size: PropTypes.number}

export const UndoIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M9 14 4 9l5-5' />
    <path d='M4 9h10.5a5.5 5.5 0 0 1 0 11H11' />
  </svg>
)

UndoIcon.propTypes = {size: PropTypes.number}

export const RedoIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='m15 14 5-5-5-5' />
    <path d='M20 9H9.5a5.5 5.5 0 0 0 0 11H13' />
  </svg>
)

RedoIcon.propTypes = {size: PropTypes.number}

export const EyeIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M2 12s3.5-7 10-7 10 7 10 7-3.5 7-10 7S2 12 2 12z' />
    <circle cx='12' cy='12' r='3' />
  </svg>
)

EyeIcon.propTypes = {size: PropTypes.number}

export const RetryIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M21 12a9 9 0 1 1-2.6-6.4L21 8' />
    <path d='M21 3v5h-5' />
  </svg>
)

RetryIcon.propTypes = {size: PropTypes.number}

export const HistoryIcon = ({size = 14}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M3 7v6h6' />
    <path d='M21 17a9 9 0 0 0-15-6.7L3 13' />
  </svg>
)

HistoryIcon.propTypes = {size: PropTypes.number}

export const CheckIcon = ({size = 14, strokeWidth = 2.6}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(strokeWidth)}>
    <path d='M20 6 9 17l-5-5' />
  </svg>
)

CheckIcon.propTypes = {size: PropTypes.number, strokeWidth: PropTypes.number}

export const CloseIcon = ({size = 14}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2.4)}>
    <path d='M18 6 6 18M6 6l12 12' />
  </svg>
)

CloseIcon.propTypes = {size: PropTypes.number}

export const DownloadIcon = ({size = 17}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M12 3v12m0 0l-4.5-4.5M12 15l4.5-4.5' />
    <path d='M4.5 17v2.5A1.5 1.5 0 0 0 6 21h12a1.5 1.5 0 0 0 1.5-1.5V17' />
  </svg>
)

DownloadIcon.propTypes = {size: PropTypes.number}

export const SendIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2.2)}>
    <path d='M12 19V5M5 12l7-7 7 7' />
  </svg>
)

SendIcon.propTypes = {size: PropTypes.number}

export const AlertIcon = ({size = 16}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <circle cx='12' cy='12' r='9' />
    <path d='M12 8v5M12 16.5v.01' />
  </svg>
)

AlertIcon.propTypes = {size: PropTypes.number}

/* ---------- "Record this version" (TK-3204) ---------- */

export const ScriptIcon = ({size = 20}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <path d='M4 6h16M4 10h16M4 14h16M4 18h10' />
  </svg>
)

ScriptIcon.propTypes = {size: PropTypes.number}

export const PointsIcon = ({size = 20}) => (
  <svg width={size} height={size} viewBox='0 0 24 24' {...strokeProps(2)}>
    <circle cx='5' cy='7' r='1.3' fill='currentColor' />
    <circle cx='5' cy='12' r='1.3' fill='currentColor' />
    <circle cx='5' cy='17' r='1.3' fill='currentColor' />
    <path d='M10 7h10M10 12h8M10 17h9' />
  </svg>
)

PointsIcon.propTypes = {size: PropTypes.number}
